import { createApiError } from '~/domain/errors';

/** Names the form field that caused a server-side rejection, so the form
 *  can paint its error border without needing to pattern-match BE copy. */
export type TUpdateOfficeErrorField =
  | 'officeName'
  | 'officeAddress'
  | 'officeType'
  | 'officeSpecialty';

/** Catch-all for BE copy, optionally tagged with the field it rejects. */
export class UpdateOfficeApiError extends createApiError<TUpdateOfficeErrorField>(
  'UpdateOfficeApiError',
) {}
